import { useMemo } from "react";
import DashboardLayout from "@/src/components/layout";
import { pressReleaseApiService } from "@/src/lib/api-services/pressReleaseApiServices";
import Link from "next/link";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";

Policy.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

export default function Policy({ data }) {
    const PolicyList = useMemo(() => {
        return data.data;
    }, [data]);

    return (
        <div className="max-w-7xl mx-auto md:py-14 py-4">
            <h1 className="md:text-3xl text-xl font-bold text-center mb-10 md:mb-16 text-black">
                Programs & Policies
            </h1>

            <div className="max-w-xl mx-auto md:px-0 px-4">
                <div className="flex flex-col rounded-lg shadow bg-primary/5 border-b border-solid border-primary/20">
                    {PolicyList.map((item) => (
                        <div
                            key={item.policyName}
                            className="flex flex-row justify-between items-center border-b border-solid border-primary/20 md:py-5 py-2 last:border-b-0 md:px-6 px-3"
                        >
                            <h2 className="md:text-lg text-md font-bold text-black">
                                {item.policyName}
                            </h2>

                            <Link
                                target="_blank"
                                href={`${NEXT_IMAGE_CDN}/${item.objectKey}`}
                                className="bg-primary text-white md:px-3 px-2 py-2 rounded md:text-sm text-xs"
                            >
                                View Detail
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export async function getServerSideProps() {
    const data = await pressReleaseApiService.PolicyList();
    return {
        props: {
            data: {
                ...data,
                seoTitle: "HOD | House Of Diagnostics | Programs & Policies",
                seoDescription:
                    "HOD | House Of Diagnostics | Programs & Policies",
                routerPath: "governance/policy ",
            },
        },
    };
}
